import { deleteProperty } from "@/services/helpers";

export const bulkDiscountAdded = (state, payload) => {
  state.list = { ...state.list, [payload.id]: payload };
};

export const reset = (state, payload) => {
  state.list = {};
  state.loaded = false;
};

export const replaceBulkDiscount = (state, payload) => {
  state.list = { ...state.list, [payload.id]: payload };
};

export const bulkDiscountRemoved = (state, payload) => {
  state.list = deleteProperty(state.list, payload.toString());
};

export const initBulkDiscounts = (state, payload) => {
  state.list = payload;
  state.loaded = true;
};
